import { createSlice } from '@reduxjs/toolkit';

const SOS_AUTH_KEY   = 'sos_auth';
const SOS_RESET_KEY  = 'sos_reset_required';
const SOS_ZONES_KEY  = 'sos_zones';

const responderSlice = createSlice({
  name: 'responder',
  initialState: {
    isResponder:           !!localStorage.getItem(SOS_AUTH_KEY),
    responderUsername:     localStorage.getItem(SOS_AUTH_KEY) || null,
    responderZones:        JSON.parse(localStorage.getItem(SOS_ZONES_KEY) || '[]'),
    responderResetRequired: localStorage.getItem(SOS_RESET_KEY) === 'true',
  },
  reducers: {
    responderLogin(state, action) {
      const { username, zones, resetRequired } = action.payload;
      state.isResponder            = true;
      state.responderUsername      = username;
      state.responderZones         = zones || [];
      state.responderResetRequired = !!resetRequired;
      localStorage.setItem(SOS_AUTH_KEY,  username);
      localStorage.setItem(SOS_RESET_KEY, String(!!resetRequired));
      localStorage.setItem(SOS_ZONES_KEY, JSON.stringify(zones || []));
    },
    responderLogout(state) {
      state.isResponder            = false;
      state.responderUsername      = null;
      state.responderZones         = [];
      state.responderResetRequired = false;
      localStorage.removeItem(SOS_AUTH_KEY);
      localStorage.removeItem(SOS_RESET_KEY);
      localStorage.removeItem(SOS_ZONES_KEY);
    },
    responderClearReset(state) {
      state.responderResetRequired = false;
      localStorage.setItem(SOS_RESET_KEY, 'false');
    },
  },
});

export const { responderLogin, responderLogout, responderClearReset } = responderSlice.actions;
export default responderSlice.reducer;
